<template>
  <el-col class="online-block">
    <el-row class="online-main" :style="getDiffStyle(0)">
      <el-col :span="14" class="online-pie">
        <common-charts index="_digital_circle" :options="onlineOp"
                       :style="getDiffStyle(1)" :key="timeStamp" autoresize/>
      </el-col>
      <el-col class="online-pie" :span="10">
        <el-row style="color: #FCB268;font-weight: bold" :style="getDiffStyle(2)">{{ sensorNum[1] }}</el-row>
        <el-row style="color: #fff;font-size: 14px;">设备总数（台）</el-row>
        <el-row style="color: #FCB268;font-weight: bold" :style="getDiffStyle(3)">{{ sensorNum[0] }}</el-row>
        <el-row style="color: #fff;font-size: 14px;">在线设备（台）</el-row>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import CommonCharts from "../../common/chart/CommonCharts";
import buildOnlineCircleConfig from "../../../config/chart/config_online_circle";

export default {
  name: "OnlineBlock",
  components: {CommonCharts},
  props: ["isFull", "sensorNum"],
  data() {
    return {
      onlineOp: {},
      timeStamp: 0
    }
  },
  watch: {
    sensorNum: function (newV, oldV) {
      this.setChart()
    }
  },
  created() {
    this.setChart()
  },
  methods: {
    getDiffStyle(styleIndex) {
      if(styleIndex === 0) return this.isFull ? 'padding: 14px;' : 'padding: 10px;'
      if(styleIndex === 1) return this.isFull ? 'height: 200px;' : 'height: 176px;'
      if(styleIndex === 2) return this.isFull ? 'font-size: 48px;margin-top: 12px;' : 'font-size: 38px;margin-top: 6px;'
      if(styleIndex === 3) return this.isFull ? 'font-size: 48px;margin-top: 16px;' : 'font-size: 38px;margin-top: 16px;'
    },
    setChart() {
      let onlineNum = this.sensorNum[0];
      let offlineNum = this.sensorNum[1] - onlineNum;
      this.onlineOp = buildOnlineCircleConfig([], [{name: '在线', value: onlineNum}, {name: '离线', value: offlineNum}], '设备在线率')
      this.timeStamp = new Date().getTime()
    }
  }
}
</script>

<style scoped>
.online-block{
  margin-left: 36px;
  height: 100%;
  width: 411px;
}
.online-main{
  height: 100%;
  width: 100%;
  background: url("../../../assets/images/digital-screen/dev-bg.png") no-repeat;
  background-size: 100% 100%;
}
.online-pie{
  height: 98%;
  margin-top: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DigitalScreen/OnlineBlock.vue